import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './services/auth.service';
import { catchError, tap } from 'rxjs/operators';
import { PreloaderService } from './components/preloader/preloader.service';
import { NotificatorService } from './services/notificator.service';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private preloader: PreloaderService,
    private notification: NotificatorService,
    private CS: CookieService,
  ) {}

  /**
   * Устанавливает & Обновляет API Token
   * @param $token
   * @private
   */
  private setNewApiToken($token: string | null) {
    this.notification.consoleNotify('AUTH', 'INTERCEPTOR', 'success', 'Updated API Token');
    if ($token !== null && $token !== undefined) {
      this.auth.updateApiToken($token);
    }
  }

  /**
   * Основной перехватчик
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const TOKEN = this.CS.get('AUTH');
    if (this.auth.checkAuthentication() || TOKEN) {
      req = req.clone({
        setHeaders: {
          // Authorization: this.auth.token
          Authorization: this.CS.get('AUTH'),
        },
      });
    } else {
      // console.log('CECK-INT-3')
    }
    return next.handle(req).pipe(
      tap((res) => {
        if (res instanceof HttpResponse) {
          const newApiToken = res.headers.get('Authentication');
          if (environment.stringCheck(newApiToken)) {
            this.setNewApiToken(newApiToken);
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('Interceptor error: ', error);
        this.notification.consoleNotify('INTERCEPTOR', 'SERVICE', 'error', 'Intercept error', {
          data: error,
        });
        if (error.status === 401 && !this.isLoginRequest(req)) {
          this.auth.handleSessionExpired();
        }
        setTimeout(() => {
          this.preloader.turnOffPreloader();
        }, 256);
        return throwError(error);
      }),
    );
  }

  private isLoginRequest(req: HttpRequest<unknown>): boolean {
    return req.method === 'POST' && (req.url === '/login' || req.url.endsWith('/login'));
  }
}
